export default __webpack_public_path__ + "static/media/imgretailSolutions.87ba9e95.svg";